import { enableExpandableTextContent } from '@organisms/page-details/enableExpandableTextContent';
import { offerActions } from '@organisms/offer-actions';

export const initOfferStateModals = () => {
  offerActions();

  enableExpandableTextContent({
    expandLink: {
      selector: '.offer-description-expander a',
    },
    content: {
      selector: '.offer-description-content',
      expandedClass: 'offer-description-content-expanded',
    },
    section: {
      selector: '.offer-description',
    },
  });
};
